export const LANGUAGE_STORAGE_KEY = 'app-language';

export const SUPPORTED_LANGUAGES = ['en', 'zh-CN', 'th', 'vi', 'ja', 'ko', 'id'] as const;

export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: AppLanguage = 'en';

export const LANGUAGE_OPTIONS: ReadonlyArray<{
    key: AppLanguage;
    flag: string;
    nativeName: string;
    intlLocale: string;
}> = [
    { key: 'en', flag: '🇬🇧', nativeName: 'English', intlLocale: 'en-US' },
    { key: 'zh-CN', flag: '🇨🇳', nativeName: '简体中文', intlLocale: 'zh-CN' },
    { key: 'th', flag: '🇹🇭', nativeName: 'ไทย', intlLocale: 'th-TH' },
    { key: 'vi', flag: '🇻🇳', nativeName: 'Tiếng Việt', intlLocale: 'vi-VN' },
    { key: 'ja', flag: '🇯🇵', nativeName: '日本語', intlLocale: 'ja-JP' },
    { key: 'ko', flag: '🇰🇷', nativeName: '한국어', intlLocale: 'ko-KR' },
    { key: 'id', flag: '🇮🇩', nativeName: 'Bahasa Indonesia', intlLocale: 'id-ID' },
];

export function isAppLanguage(value: unknown): value is AppLanguage {
    return SUPPORTED_LANGUAGES.includes(value as AppLanguage);
}

export function getInitialLanguage(): AppLanguage {
    const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return isAppLanguage(saved) ? saved : DEFAULT_LANGUAGE;
}

export function getIntlLocale(language: string): string {
    return (
        LANGUAGE_OPTIONS.find((option) => option.key === language)?.intlLocale ||
        LANGUAGE_OPTIONS[0].intlLocale
    );
}
